<template>
  <div class='feedback_index'>
    <header class='tabs'>
      <div :class='["tab",curTab == 0 ? "on" : ""]' @click="switchTab(0)">意见反馈</div>
      <div :class='["tab",curTab == 1 ? "on" : ""]' @click="switchTab(1)">反馈记录</div>
    </header>
    <form v-if='curTab == 0'>
      <div class='line-height'></div>
      <div class='form-line border-bottom'>
        <div class='text'>姓名</div>
        <div class='input'>
          <input type="text" v-model="formData.name" placeholder="请填写姓名">
        </div>
      </div>
      <div class='form-line'>
        <div class='text'>手机</div>
        <div class='input'>
          <input type="number" v-model="formData.mobile_phone" placeholder="请填写手机号码">
        </div>
      </div>
      <div class='line-height'></div>
      <div class='form-textarea'>
        <div class='text border-bottom'>反馈内容</div>
        <div class='textarea'>
          <textarea v-model="formData.content" placeholder="请输入" rows="3"></textarea>
        </div>
      </div>
      <div class='line-height'></div>
      <div class='form-textarea'>
        <div class='text border-bottom'>图片上传</div>
        <div class='upload-images'>
          <images-upload :imageList="imageList" @upload='imageUpload' @delete='imageDelete'></images-upload>
        </div>
      </div>
      <div class='form-btn' @click="formSubmit">提交</div>
    </form>

    <nav v-if='curTab == 1'>
      <list :nodata='nodata' :loading='loading' :finished='finished' :error='error' @load='getList'>
        <ul class='items'>
          <li class='item' v-for='(item, index) in feedbackList' :key='item.id'>
            <router-link :to="{ path: '/feedback/detail', query: { id: item.id }}">
              <div class='top border-bottom'>
                <div class='title'>
                  <div class='linkman'>
                    <span>{{item.name || '匿名'}}</span>
                    <span>{{item.mobile_phone}}</span>
                  </div>
                  <div class='time'>
                    <span>{{item.create_time}}</span>
                  </div>
                </div>
                <div class='text'>
                  {{item.content}}
                </div>
              </div>
            </router-link>
            <div class='bottom'>
              <span class='del' @click='delData(item.id, index)'>
                <i class='jcicon jcicon-shanchu'></i>
                删除
              </span>
            </div>
          </li>
        </ul>
      </list>
    </nav>

  </div>
</template>

<script>
import axios from 'axios'
import ImagesUpload from '@/components/hzjc/images-upload/Index'
import List from '@/components/hzjc/list/Index'
export default {
  name: 'FeedbackIndex',
  components: {
    ImagesUpload,
    List
  },
  data () {
    return {
      curTab: 0,
      imageList: [],
      formData: {},
      feedbackList: [],
      nodata: false,
      loading: false,
      finished: false,
      error: false
    }
  },
  methods: {
    getBaseInfo () {
    },
    switchTab (index) {
      let vm = this
      vm.curTab = index
      if (index === 1) {
        vm.getList(1)
      }
    },
    imageUpload (res) {
      let newImageList = this.imageList.concat(res.uploadImageList)
      this.imageList = newImageList
    },
    imageDelete (res) {
      let imageList = this.imageList
      imageList.splice(res.index, 1)
      this.imageList = imageList
    },
    getList (page) { // page=0时，页数+1 page=1时，页数在第1页重新加载
      let vm = this
      let curPage
      if (vm.loading) {
        return false
      }
      vm.loading = true
      if (page !== 1) {
        vm.page = vm.page || 1
        curPage = vm.page + 1
      } else {
        curPage = 1
      }
      axios.post('/wechat.php/Feedback/getFeedbackList', {
        user_id: localStorage.user_id,
        page: curPage
      }).then(function (res) {
        vm.loading = false
        res = res.data
        if (res.code === 1) {
          if (curPage === 1) {
            vm.feedbackList = []
          }
          let list = vm.feedbackList
          list = list.concat(res.data.data_list.data)
          vm.feedbackList = list
          vm.page = curPage
          if (res.data.data_list.current_page >= res.data.data_list.last_page) {
            vm.finished = true
          }
        } else {
          vm.error = true
        }
      })
    },
    delData (id, index) {
      let vm = this
      if (!confirm('确定删除吗？')) {
        return false
      }
      axios.post('/wechat.php/Feedback/removeFeedback', {
        user_id: localStorage.user_id,
        id_list: id
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          vm.getList(1)
        } else {
          alert(res.message)
          return false
        }
      })
    },
    formSubmit () {
      let vm = this
      axios.post('/wechat.php/Feedback/feedback', {
        user_id: localStorage.user_id,
        name: vm.formData.name,
        mobile_phone: vm.formData.mobile_phone,
        content: vm.formData.content,
        image_path: vm.imageList.join(',')
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          vm.curTab = 1
          vm.getList(1)
        } else {
          alert(res.message)
          return false
        }
      })
    }
  },
  mounted () {
    this.getBaseInfo()
  }
}
</script>

<style lang="stylus">
  @import '~@styles/mixins.styl'
  @import '~@styles/varibles.styl'
  .ceshi
    width 750px
    height 200px
    background #000
  .feedback_index
    padding-bottom 1.2rem !important
    .tabs
      height 1rem
      line-height 1rem
      box-sizing border-box
      display flex
      text-align center
      background #fff
      font-size .36rem
      .tab
        margin 0 15%
        flex 1
      .tab.on
        border-bottom 3px solid #F93A42
    form
      .form-line
        padding 0 4%
        background #fff
        height 1rem
        line-height 1rem
        display flex
        .text
          width 15%
        .input
          flex 1
          input
            display block
            width 100%
            height 100%
      .form-textarea
        padding 0 4%
        background #fff
        .text
          width 100%
          height 1rem
          line-height 1rem
        .textarea
          width 100%
          padding .1rem 0
          line-height .6rem
          textarea
            display block
            width 100%
            height 100%
        .upload-images
          width 100%
          padding .1rem 0
      .form-btn
        position fixed
        bottom 0
        background $mainColor
        color #fff
        width 100%
        height 1rem
        line-height 1rem
        text-align center
    nav
      .items
        width 100%
        .item
          margin-top .2rem
          background #fff
          .top
            padding .3rem 4%
            .title
              .linkman
                line-height .4rem
                height .4rem
                span:nth-child(1)
                  padding-right .4rem
              .time
                line-height .4rem
                height .4rem
                color $darkGrayColor
                font-size .28rem
            .text
              padding-top .3rem
              font-size .3rem
              color $lightBlackColor
              text-overflow ellipsis
              display -webkit-box
              -webkit-box-orient vertical
              -webkit-line-clamp 4
              line-height .4rem
              max-height 1.6rem
              overflow hidden
          .bottom
            padding 0 4%
            line-height 1rem
            height 1rem
            overflow hidden
            span.del
              color $defaultGrayColor
              float right
              font-size .3rem
</style>



// WEBPACK FOOTER //
// src/pages/feedback/Index.vue